import api from './api';

export const documentsAPI = {
  upload: (clientId, formData) => api.post(`/api/clients/${clientId}/documents/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  list: (clientId, params) => api.get(`/api/clients/${clientId}/documents`, { params }),
  get: (docId) => api.get(`/api/documents/${docId}`),
  download: (docId) => api.get(`/api/documents/${docId}/download`, { responseType: 'blob' }),
  versions: (docId) => api.get(`/api/documents/${docId}/versions`),
  updateMetadata: (docId, data) => api.patch(`/api/documents/${docId}`, data),
  // Document review status + AI classification (Module D / B#7)
  setStatus: (docId, status) => api.patch(`/api/documents/${docId}`, { status }),
  classify: (docId) => api.post(`/api/documents/${docId}/classify`),
  // Firm-wide list + preview + OCR (Module D / B#7)
  listAll: (params) => api.get('/api/documents', { params }),
  preview: (docId) => api.get(`/api/documents/${docId}/preview`, { responseType: 'blob' }),
  ocr: (docId) => api.post(`/api/documents/${docId}/ocr`),
};

export const DOCUMENT_CATEGORY_LABELS = {
  bank_statement: 'Bank Statement', payslip: 'Payslip', payment_summary: 'Payment Summary',
  invoice: 'Invoice', receipt: 'Receipt', loan_statement: 'Loan Statement',
  rental_statement: 'Rental Statement', motor_vehicle_record: 'Motor Vehicle',
  super_document: 'Super', bas_report: 'BAS Report', profit_and_loss: 'Profit & Loss',
  balance_sheet: 'Balance Sheet', xero_export: 'Xero Export',
  ato_correspondence: 'ATO Correspondence', asic_document: 'ASIC', trust_deed: 'Trust Deed',
  company_constitution: 'Company Constitution', tax_notice: 'Tax Notice', other: 'Other',
};

// Document review statuses (spec Module D)
export const DOCUMENT_STATUS_LABELS = {
  uploaded: 'Uploaded',
  reviewed: 'Reviewed',
  needs_clarification: 'Needs Clarification',
  accepted: 'Accepted',
};

export const DOCUMENT_STATUS_COLORS = {
  uploaded: 'bg-muted text-foreground/90',
  reviewed: 'bg-blue-100 text-blue-700',
  needs_clarification: 'bg-amber-100 text-amber-700',
  accepted: 'bg-green-100 text-green-700',
};

export const notesAPI = {
  list: (clientId) => api.get(`/api/clients/${clientId}/notes`),
  create: (clientId, data) => api.post(`/api/clients/${clientId}/notes`, data),
  togglePin: (noteId) => api.patch(`/api/notes/${noteId}/pin`),
};
